// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__2Q0kj","agendaChip":"styles_agendaChip__306Ac","agendaChipText":"styles_agendaChipText__Y0oTe"};